import { BUTTON_ELEMENTS as BUTTON_SERIALIZE } from '@lumapps/wrex-button/plugin/html/serialize';
import { CODE_BLOCK_ELEMENTS as CODE_BLOCK_SERIALIZE } from '@lumapps/wrex-code-block/plugin/html/serialize';
import { COLUMNS_ELEMENTS as COLUMNS_SERIALIZE } from '@lumapps/wrex-columns/plugin/html/serialize';
import { EMBEDDED_MAP_ELEMENTS as EMBEDDED_MAP_SERIALIZE } from '@lumapps/wrex-embedded-map/plugin/html/serialize';
import { EMBEDDED_VIDEO_ELEMENTS as EMBEDDED_VIDEO_SERIALIZE } from '@lumapps/wrex-embedded-video/plugin/html/serialize';
import { ENHANCED_IMAGE_ELEMENTS as ENHANCED_IMAGE_SERIALIZE } from '@lumapps/wrex-enhanced-image/plugin/html/serialize';
import { FILE_ELEMENTS as FILE_SERIALIZE } from '@lumapps/wrex-file/plugin/html/serialize';
import { IFRAME_ELEMENTS as IFRAME_SERIALIZE } from '@lumapps/wrex-iframe/plugin/html/serialize';
import { INFO_PANEL_ELEMENTS as INFO_PANEL_SERIALIZE } from '@lumapps/wrex-info-panel/plugin/html/serialize';
import { LINK_PREVIEW_ELEMENTS as LINK_PREVIEW_SERIALIZE } from '@lumapps/wrex-link-preview/plugin/html/serialize';
import { LINK_ELEMENTS as LINK_SERIALIZE } from '@lumapps/wrex-link/plugin/html/serialize';
import { LIST_ELEMENTS as LIST_SERIALIZE } from '@lumapps/wrex-list/plugin/html/serialize';
import { PLAY_VIDEO_ELEMENTS as PLAY_VIDEO_SERIALIZE } from '@lumapps/wrex-play-video/plugin/html/serialize';
import { QUOTE_ELEMENTS as QUOTE_SERIALIZE } from '@lumapps/wrex-quote/plugin/html/serialize';
import { TABLE_ELEMENTS as TABLE_SERIALIZE } from '@lumapps/wrex-table/plugin/html/serialize';
import {
    TYPOGRAPHY_ELEMENTS as TYPOGRAPHY_SERIALIZE,
    TYPOGRAPHY_MARKS as MARKS_SERIALIZE,
} from '@lumapps/wrex-typography/plugin/html/serialize';
import { USER_MENTION_ELEMENTS as USER_MENTION_SERIALIZE } from '@lumapps/wrex-user-mention/plugin/html/serialize';

import { HTMLSerializeOptions } from './toHTML/types';

const HTML_SERIALIZATION_ELEMENTS = {
    ...TYPOGRAPHY_SERIALIZE,
    ...CODE_BLOCK_SERIALIZE,
    ...INFO_PANEL_SERIALIZE,
    ...LIST_SERIALIZE,
    ...ENHANCED_IMAGE_SERIALIZE,
    ...USER_MENTION_SERIALIZE,
    ...LINK_PREVIEW_SERIALIZE,
    ...LINK_SERIALIZE,
    ...TABLE_SERIALIZE,
    ...QUOTE_SERIALIZE,
    ...EMBEDDED_MAP_SERIALIZE,
    ...EMBEDDED_VIDEO_SERIALIZE,
    ...IFRAME_SERIALIZE,
    ...PLAY_VIDEO_SERIALIZE,
    ...FILE_SERIALIZE,
    ...BUTTON_SERIALIZE,
    ...COLUMNS_SERIALIZE,
} as const;

const HTML_SERIALIZATION_MARKS = {
    ...MARKS_SERIALIZE,
} as const;

export const getHtmlSerializationOptions = ({
    elements,
    marks,
}: {
    elements: readonly (keyof typeof HTML_SERIALIZATION_ELEMENTS)[];
    marks: readonly (keyof typeof HTML_SERIALIZATION_MARKS)[];
}): HTMLSerializeOptions => {
    const htmlSerializeElements = Object.fromEntries(
        elements.map((element) => [element, HTML_SERIALIZATION_ELEMENTS[element]]),
    );
    const htmlSerializeMarks = Object.fromEntries(marks.map((mark) => [mark, HTML_SERIALIZATION_MARKS[mark]]));

    return {
        elements: htmlSerializeElements,
        marks: htmlSerializeMarks,
    };
};
